import { type ComputedRef } from 'vue';
import type ItineraryModule from '@itinerary/ItineraryModule';

export function useCurrentItineraryModule<
    T extends ItineraryModule = ItineraryModule,
>(): ComputedRef<T> {
    const itineraryStore = useItineraryStore();
    const searchFormStore = useSearchFormStore();
    return computed(() =>
        itineraryStore.getItineraryModule<T>(searchFormStore.reserveType)
    );
}
